import * as actionTypes from './actionTypes'
import { fromJS } from 'immutable'

export const getActivityData = () => ({
    type: actionTypes.GET_ACTIVITY_DATA
})

export const setActivityData = data => ({
    type: actionTypes.SET_ACTIVITY_DATA,
    data
})

export const setActivitySelectData = data => ({
    type: actionTypes.SET_ACTIVITY_SELECT_DATA,
    data
})




